import type { Season, SeasonSummary } from '@/services/api'
import { formatDate } from '@/composable/formatDate'
import { api } from '@/services'
import { useGlobalStore } from '@/stores/global'

export function formattedSeasonDates(season: Season) {
  let dateStr = season.start_date ? formatDate(season.start_date) : ''
  dateStr += ' &ndash; ' + (season.end_date ? formatDate(season.end_date) : '')
  dateStr = dateStr !== '' ? '<br>' + dateStr : ''

  dateStr += '<br />Tournament: '
  dateStr += season.tournament_date ? formatDate(season.tournament_date) : ''

  return dateStr
}

export async function getSeason(seasonId: number): Promise<Season | undefined> {
  const globalStore = useGlobalStore()

  let season = undefined
  if (!seasonId) {
    return season
  }

  try {
    globalStore.incrementLoading()
    const seasonData = await api.api.getSeason(seasonId).then((res) => res.data)
    if (seasonData?.data) {
      season = seasonData.data
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return season
}

export function createSeasonSummary(season: Season): SeasonSummary {
  return {
    id: season.id,
    host_id: season.host_id,
    name: season.name,
    start_date: season.start_date,
    end_date: season.end_date,
    tournament_date: season.tournament_date ?? undefined,
    winner_id: season.winner_id ?? undefined,
    active_week: season.active_week,
    weeks: season.weeks?.map((week) => ({
      value: week.value ?? 0, // Assign a default value if `value` is undefined
      text: week.text ?? '' // Assign a default value if `text` is undefined
    }))
  }
}
